module.exports = __webpack_public_path__ + "static/media/fix-403-Forbidden-Error.5dcbe81f.png";